module.exports = __webpack_public_path__ + "img/095-pitcairn-islands.4d842b78.svg";